import PropTypes from "prop-types";
import React from "react";

import Label from '../formsUi/common/label/Label';
import ToggleSwitch from '../formsUi/toggleSwitch/ToggleSwitch';

const FormToggleControls = ({
    dataField,
    labelName,
    targetId = "",
    name,
    value,
    fieldSetting = {},
    onChange,
    ...otherProps
}) => {

    const handleToggleChange = (event) => {
        if (onChange) onChange(dataField, event.target.checked);
    };

    return (
        <>
            <div className="" id={targetId}>
                {labelName && <Label labelName={labelName} htmlFor={name} />}
                <ToggleSwitch
                    value={value}
                    onChange={handleToggleChange}
                    label="Active"
                    isDisabled={fieldSetting?.isDisable}
                    {...otherProps}
                />
            </div>
        </>
    );
};

FormToggleControls.propTypes = {
    keyId: PropTypes.string,
    targetId: PropTypes.string,
    dataField: PropTypes.string.isRequired,
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    formSetting: PropTypes.object,
    overRideProps: PropTypes.object,
    fieldSetting: PropTypes.shape({
        subTitle: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.object),
        isFormControl: PropTypes.bool,
        defaultOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isDisable: PropTypes.bool,
    }),
    isRequired: PropTypes.bool,
    onChange: PropTypes.func,
    onValidation: PropTypes.func,
    onBlure: PropTypes.func,
    onActionChange: PropTypes.func
};

export default FormToggleControls;